import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_56: FaireProductEntity = {
  token: "catalog_prod_prod-56",
  type: "product",
  name: "Black Mango Wood Milking Stool - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 83.33,
  msrpDollars: 208.33,
  sku: "JA0056",
  caseSize: 6,
  material: "Linen",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 454,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_gift-wrapping"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
